import React from 'react';
import { createBrowserRouter, RouteObject } from 'react-router-dom';

import { GameId, ModCategory } from '../constants/enums';
import { APP_ROUTES } from '../constants/routes';
import { GameProfileScreen } from '../features/games/screens/GameProfileScreen/GameProfileScreen';
import { HomeScreen } from '../features/home/screens/HomeScreen/HomeScreen';
import { ModListScreen } from '../features/mods/screens/ModListScreen/ModListScreen';
import { ModProfileScreen } from '../features/mods/screens/ModProfileScreen/ModProfileScreen';
import { PrivacyScreen } from '../features/privacy/screens/PrivacyScreen/PrivacyScreen';
import { SimrLabsScreen } from '../features/simrlabs/screens/SimrLabsScreen/SimrLabsScreen';
import { MainLayout } from '../layouts/MainLayout/MainLayout';
import { RouteError } from './RouteError/RouteError';

export const routesConfig: RouteObject[] = [
  {
    path: APP_ROUTES.HOME,
    element: <MainLayout />,
    errorElement: <RouteError />,
    children: [
      {
        index: true,
        element: <HomeScreen />,
      },
      {
        path: APP_ROUTES.MODS.slice(1),
        element: <ModListScreen />,
      },
      {
        path: APP_ROUTES.VR_MODS.slice(1),
        element: <ModListScreen category={ModCategory.VR} />,
      },
      {
        path: APP_ROUTES.UEVR_MODS.slice(1),
        element: <ModListScreen category={ModCategory.UEVR} />,
      },
      {
        path: APP_ROUTES.HEAD_TRACKING_MODS.slice(1),
        element: <ModListScreen category={ModCategory.HEAD_TRACKING} />,
      },
      {
        path: APP_ROUTES.PROFILE.slice(1),
        element: <ModProfileScreen />,
      },
      {
        path: APP_ROUTES.GAMES.slice(1),
        element: <GameProfileScreen id={GameId.SAIL_TO_UNKNOWN} />,
      },
      {
        path: APP_ROUTES.GAME_PROFILE.slice(1),
        element: <GameProfileScreen />,
      },
      {
        path: APP_ROUTES.SIMRLABS.slice(1),
        element: <SimrLabsScreen />,
      },
      {
        path: APP_ROUTES.PRIVACY.slice(1),
        element: <PrivacyScreen />,
      },
    ],
  },
];

export const router = createBrowserRouter(routesConfig, {
  future: {
    v7_relativeSplatPath: true,
  },
});
